import { Actions, Reducers } from '../state';
import { ReviewFormFieldError, ReviewFormProps } from '../types';

export type ReviewFormMappedState = {
  fieldsErrors: ReviewFormFieldError[];
} & Pick<ReviewFormProps, 'totalScore'> &
  Pick<ReviewFormProps, 'body' | 'pros' | 'cons'> &
  Pick<ReviewFormProps, 'timeUsage' | 'shop' | 'authorName' | 'authorEmail'>;
export const mapStoreToProps = (state: ReturnType<typeof Reducers.formState>): ReviewFormMappedState => {
  return {
    totalScore: state.totalScore,
    body: state.bodyText,
    pros: state.prosText,
    cons: state.consText,
    timeUsage: state.authorTimeUsage ?? null,
    shop: state.authorShop ?? null,
    authorName: state.authorName,
    authorEmail: state.authorEmail,
    fieldsErrors: state.fieldsErrors,
  };
};

export type ReviewFormDispatchMap = Pick<ReviewFormProps, 'setTotalScore'> &
  Pick<ReviewFormProps, 'setReviewBodyText' | 'setReviewConsText' | 'setReviewProsText'> &
  Pick<ReviewFormProps, 'setTimeUsage' | 'setAuthorName' | 'setAuthorEmail'>;

export const mapDispatchToProps = (
  dispatch: React.Dispatch<Reducers.FormReducerActions>,
): ReviewFormDispatchMap => ({
  setTotalScore: (score) => dispatch(Actions.setTotalScore(score)),
  setReviewBodyText: (text) => dispatch(Actions.setReviewBodyText(text)),
  setReviewConsText: (text) => dispatch(Actions.setReviewConsText(text)),
  setReviewProsText: (text) => dispatch(Actions.setReviewProsText(text)),
  setTimeUsage: (value, indexFromOne) =>
    dispatch(Actions.setAuthorDetailTimeUsage({ timeUsage: value, indexFromOne })),
  setAuthorName: (value) => dispatch(Actions.setAuthorName(value)),
  setAuthorEmail: (value) => dispatch(Actions.setAuthorEmail(value)),
});
